<template>
  <div class="animated fadeIn">
    <div v-if="loading">
      <b-row>
        <b-col md="6">
          <atom-spinner
            :animation-duration="1000"
            :size="60"
            color="#ff1d5e"
            class="float-right my-4"
          />
        </b-col>
      </b-row>
    </div>
    <div v-else>
      <b-row>
        <b-col md="12">
          <component-header
            title="Build Generation"
            :hasSearch="false"
            :hasReload="false"
            :hasCreate="false"
            :hasback="false"
          />
        </b-col>
        <b-col>
          <ValidationObserver ref="observer">
            <b-card>
              <b-row>
                <b-col md="12">
                  <b-tabs v-model="tabIndex">
                    <b-tab title="Build Generation">
                      <div class="">
                        <v-stepper
                          alt-labels
                          class="user_bg_color"
                          v-model="stepperIndex"
                        >
                          <v-stepper-header>
                            <v-stepper-step :step="1" :complete="stepperIndex > 1">
                              <template v-slot:icon v-if="stepperIndex > 1">
                                <i class="icon fas fa-check"></i>
                              </template>
                              <div class="step-title mr-3">Choose App Platform</div>
                            </v-stepper-step>
                            <v-divider></v-divider>

                            <v-stepper-step :step="2" :complete="stepperIndex > 2">
                              <template v-slot:icon v-if="stepperIndex > 2">
                                <i class="icon fas fa-check"></i>
                              </template>
                              <div class="step-title mr-3">App Details</div>
                            </v-stepper-step>
                            <v-divider></v-divider>

                            <v-stepper-step :step="3" :complete="stepperIndex > 3">
                              <template v-slot:icon v-if="stepperIndex > 3">
                                <i class="icon fas fa-check"></i>
                              </template>
                              <div class="step-title mr-3">Customize Brand Theme</div>
                            </v-stepper-step>
                            <v-divider></v-divider>

                            <v-stepper-step
                              v-if="selectedPlatform !== 'web'"
                              :step="4"
                              :complete="stepperIndex > 4"
                            >
                              <template v-slot:icon v-if="stepperIndex > 4">
                                <i class="icon fas fa-check"></i>
                              </template>
                              <div class="step-title ml-3">Configure Splash Screen</div>
                            </v-stepper-step>
                            <v-divider v-if="selectedPlatform !== 'web'"></v-divider>

                            <v-stepper-step
                              v-if="selectedPlatform !== 'web'"
                              :step="5"
                              :complete="stepperIndex > 5"
                            >
                              <template v-slot:icon v-if="stepperIndex > 5">
                                <i class="icon fas fa-check"></i>
                              </template>
                              <div class="step-title ml-3">App Icon & Alerts</div>
                            </v-stepper-step>
                            <v-divider v-if="selectedPlatform !== 'web'"></v-divider>

                            <v-stepper-step
                              :step="selectedPlatform === 'web' ? 4 : 6"
                              :complete="
                                stepperIndex > (selectedPlatform === 'web' ? 4 : 6)
                              "
                            >
                              <template
                                v-slot:icon
                                v-if="stepperIndex > (selectedPlatform === 'web' ? 4 : 6)"
                              >
                                <i class="icon fas fa-check"></i>
                              </template>
                              <div class="step-title ml-4">Finalize Build</div>
                            </v-stepper-step>
                          </v-stepper-header>

                          <v-stepper-items>
                            <v-stepper-content :step="1">
                              <ChooseAppPlatform
                                v-slot:footer-button="{ data }"
                                @select-platform="selectedPlatform = $event"
                                :selected-platform="selectedPlatform"
                              >
                                <div class="stepper-btn-row">
                                  <b-button
                                    variant="primary"
                                    class="stepper-btn"
                                    :disabled="!selectedPlatform"
                                    @click="handleChooseAppPlatformNext(data)"
                                    >Next</b-button
                                  >
                                </div>
                              </ChooseAppPlatform>
                            </v-stepper-content>
                            <v-stepper-content :step="2">
                              <AppDetails
                                v-slot:footer-button="{ data }"
                                :selectedPlatform="selectedPlatform"
                                :loginBgImg="images.loginBgImg"
                                @update-login-bg-img="uploadImage('loginBgImg', $event)"
                              >
                                <div class="stepper-btn-row">
                                  <b-button
                                    variant="secondary"
                                    class="stepper-btn"
                                    @click="
                                      stepperIndex = 1;
                                      selectedPlatform = null;
                                    "
                                    >Previous</b-button
                                  >
                                  <b-button
                                    :disabled="!images.loginBgImg"
                                    variant="primary"
                                    class="stepper-btn"
                                    @click="handleAppDetailsNext(data)"
                                    >Next</b-button
                                  >
                                </div>
                              </AppDetails>
                            </v-stepper-content>
                            <v-stepper-content :step="3">
                              <CustomizeBrandTheme
                                v-slot:footer-button="{ data }"
                                @update-logo="uploadImage('logo', $event)"
                                :selectedPlatform="selectedPlatform"
                                :appLogo="images.logo"
                                :appName="appName"
                                :tagLine="tagLine"
                              >
                                <div class="stepper-btn-row">
                                  <b-button
                                    variant="secondary"
                                    class="stepper-btn"
                                    @click="stepperIndex = 2"
                                    >Previous</b-button
                                  >
                                  <b-button
                                    :disabled="!images.logo"
                                    variant="primary"
                                    class="stepper-btn"
                                    @click="handleCustomizeBrandThemeNext(data)"
                                    >{{ ThemeNextButtonName }}</b-button
                                  >
                                </div>
                              </CustomizeBrandTheme>
                            </v-stepper-content>
                            <v-stepper-content
                              v-if="selectedPlatform !== 'web'"
                              :step="4"
                            >
                              <ConfigureSplashScreen
                                v-slot:footer-button="{ data }"
                                @update-splash-icon="uploadImage('splashIcon', $event)"
                                :splashIcon="images.splashIcon"
                              >
                                <div class="stepper-btn-row">
                                  <b-button
                                    variant="secondary"
                                    class="stepper-btn"
                                    @click="stepperIndex = 3"
                                    >Previous</b-button
                                  >
                                  <b-button
                                    :disabled="!images.splashIcon"
                                    variant="primary"
                                    class="stepper-btn"
                                    @click="handleSplashScreenNext(data)"
                                    >Next</b-button
                                  >
                                </div>
                              </ConfigureSplashScreen>
                            </v-stepper-content>
                            <v-stepper-content
                              v-if="selectedPlatform !== 'web'"
                              :step="5"
                            >
                              <AppIconsAlerts
                                v-slot:footer-button="{ data }"
                                @update-logo="uploadImage('logo', $event)"
                                @update-notification-icon="
                                  uploadImage('notificationIcon', $event)
                                "
                                :appLogo="images.logo"
                                :notificationIcon="images.notificationIcon"
                                :appName="appName"
                              >
                                <div class="stepper-btn-row">
                                  <b-button
                                    variant="secondary"
                                    class="stepper-btn"
                                    @click="stepperIndex = 4"
                                    >Previous</b-button
                                  >
                                  <b-button
                                    :disabled="!images.notificationIcon"
                                    variant="primary"
                                    class="stepper-btn"
                                    @click="shouBuildGenerationPopup()"
                                    >Generate Build</b-button
                                  >
                                </div>
                              </AppIconsAlerts>
                            </v-stepper-content>
                            <v-stepper-content :step="selectedPlatform === 'web' ? 4 : 6">
                              <FinalizeBuild
                                :phases="(buildProgress && buildProgress.phases) || []"
                                @update-build-status="handleBuildStatus"
                                v-slot:footer-button="{ data }"
                              >
                                <div
                                  class="stepper-btn-row"
                                  v-if="finalBuildStatus === 'COMPLETED'"
                                >
                                  <b-button
                                    variant="primary"
                                    class="stepper-btn"
                                    @click="goToCreateNewBuild"
                                    >Create New Build</b-button
                                  >
                                  <b-button
                                    variant="primary"
                                    class="stepper-btn"
                                    @click="goToBuildActivity"
                                    >Go to Build Activity</b-button
                                  >
                                </div>
                                <div
                                  class="stepper-btn-row"
                                  v-else-if="finalBuildStatus === 'FAILED'"
                                >
                                  <b-button
                                    variant="primary"
                                    class="stepper-btn"
                                    @click="goToCreateNewBuild"
                                    >Create New Build</b-button
                                  >
                                  <b-button
                                    variant="primary"
                                    class="stepper-btn"
                                    @click="goToBuildActivity"
                                    >Go to Build Activity</b-button
                                  >
                                </div>
                              </FinalizeBuild>
                            </v-stepper-content>
                          </v-stepper-items>
                        </v-stepper>
                      </div>
                    </b-tab>
                    <b-tab title="Build Activity">
                      <b-container fluid>
                        <b-row class="mt-3">
                          <b-col md="11">
                            <h4>Recent Builds</h4>
                          </b-col>
                          <b-col md="1" class="text-right">
                            <b-button
                              size="sm"
                              variant="primary"
                              style="width: 42px; height: 35px; float: right"
                              @click="fetchStatus()"
                              :disabled="loading"
                            >
                              <span
                                v-if="loading"
                                class="fa fa-refresh fa-spin"
                                style="font-size: 15px"
                              />
                              <span
                                v-else
                                class="fa fa-refresh"
                                style="font-size: 15px"
                              />
                            </b-button>
                          </b-col>
                        </b-row>
                        <b-row>
                          <b-col md="12">
                            <b-table
                              :dark="dark"
                              :hover="hover"
                              :striped="striped"
                              :bordered="bordered"
                              :small="small"
                              :fixed="fixed"
                              responsive
                              class="tableRadius"
                              :items="latestBuildArray"
                              :fields="columnsRecent"
                              :filter="filter"
                              thead-class="header"
                              show-empty
                            >
                              <template #cell(buildFileUrl)="data">
                                <a
                                  v-if="
                                    data.item.buildFileUrl &&
                                    data.item.buildFileUrl !== '-' &&
                                    data.item.appType === 'customer' &&
                                    data.item.platform === 'web'
                                  "
                                  :href="data.item.buildFileUrl"
                                  target="_blank"
                                  class="url-link"
                                >
                                  {{ data.item.buildFileUrl }}
                                </a>
                                <span
                                  v-else-if="!data.item.buildFileUrl"
                                  @click="checkBuildProgress(data.item)"
                                  class="url-link"
                                >
                                  Check Build Progress
                                </span>
                                <span v-else>{{
                                  data.item.buildFileUrl && data.item.buildFileUrl !== "-"
                                    ? data.item.buildFileUrl
                                    : "-"
                                }}</span>
                              </template>
                              <template #cell(appType)="data">
                                {{ capitalizeFirstLetter(data.item.appType) }}
                                {{ data.item.platform }}
                              </template>
                            </b-table>
                          </b-col>
                        </b-row>
                        <b-row
                          class="mt-3"
                          v-if="
                            historyList &&
                            historyList.response &&
                            historyList.response.length > 0
                          "
                        >
                          <b-col md="12">
                            <h4>Previous Builds</h4>
                          </b-col>
                        </b-row>
                        <b-row
                          v-if="
                            historyList &&
                            historyList.response &&
                            historyList.response.length > 0
                          "
                        >
                          <b-col md="12">
                            <b-table
                              :dark="dark"
                              :hover="hover"
                              :striped="striped"
                              :bordered="bordered"
                              :small="small"
                              :fixed="fixed"
                              responsive
                              class="tableRadius"
                              :items="historyList && historyList.response"
                              :fields="columnsPrevious"
                              :filter="filter"
                              thead-class="header"
                              show-empty
                            >
                              <template #cell(buildFileUrl)="data">
                                <a
                                  v-if="
                                    data.item.buildFileUrl &&
                                    data.item.buildFileUrl !== '-' &&
                                    data.item.appType === 'customer' &&
                                    data.item.platform === 'web'
                                  "
                                  :href="data.item.buildFileUrl"
                                  target="_blank"
                                  class="url-link"
                                >
                                  {{ data.item.buildFileUrl }}
                                </a>
                                <span
                                  v-else-if="!data.item.buildFileUrl"
                                  @click="checkBuildProgress(data.item)"
                                  class="url-link"
                                >
                                  Check Build Progress
                                </span>
                                <span v-else>{{
                                  data.item.buildFileUrl && data.item.buildFileUrl !== "-"
                                    ? data.item.buildFileUrl
                                    : "-"
                                }}</span>
                              </template>
                              <template #cell(appType)="data">
                                {{ capitalizeFirstLetter(data.item.appType) }}
                                {{ data.item.platform }}
                              </template>
                            </b-table>
                          </b-col>
                        </b-row>
                      </b-container></b-tab
                    >
                    <b-tab title="Domain Configuration">
                      <DomainConfiguration />
                    </b-tab>
                  </b-tabs>
                </b-col>
              </b-row>
            </b-card>
          </ValidationObserver>
        </b-col>
      </b-row>
      <b-modal
        v-model="showGenerateBuildPopup"
        title="Generate Build"
        hide-footer
        size="md"
        centered
      >
        <div class="text-center">
          <div style="margin-bottom: 18px; margin-top: 10px">
            <b-icon icon="check2-circle" variant="success" font-scale="3" />
          </div>
          <h5 class="mb-3">Are you sure you want to start building your application?</h5>
          <p class="mb-2">
            This process may take {{ buildTimeRange }}, depending on the current queue
          </p>
          <p class="mb-4" style="font-size: 13px; color: #888">
            After confirmation, you will be redirected to the Build Progress screen where
            you can monitor real-time updates
          </p>
          <div class="popup-btn-row">
            <b-button variant="secondary" class="popup-btn" @click="cancelGenerateBuild"
              >Cancel</b-button
            >
            <b-button variant="success" class="popup-btn" @click="confirmGenerateBuild"
              >Start Build</b-button
            >
          </div>
        </div>
      </b-modal>
    </div>
  </div>
</template>
<script>
import ChooseAppPlatform from "@/components/BuildGeneration/ChooseAppPlatform.vue";
import AppDetails from "@/components/BuildGeneration/AppDetails.vue";
import CustomizeBrandTheme from "@/components/BuildGeneration/CustomizeBrandTheme.vue";
import ConfigureSplashScreen from "@/components/BuildGeneration/ConfigureSplashScreen.vue";
import AppIconsAlerts from "@/components/BuildGeneration/AppIconsAlerts.vue";
import FinalizeBuild from "@/components/BuildGeneration/FinalizeBuild.vue";
import DomainConfiguration from "@/components/BuildGeneration/DomainConfiguration.vue";
import profile from "@/components/profile/profileCategory";
import currentUserData from "@/mixins/currentUser";
import VueUploadMultipleImage from "@/components/FormElements/VueUploadMultipleImage.vue";
import SingleImage from "@/components/Common/Image.vue";
import { AtomSpinner } from "epic-spinners";
import { mapState } from "vuex";
import mobileView from "@/views/profile/mobileView.vue";
import {
  ValidationProvider,
  ValidationObserver,
  Validator,
} from "vee-validate/dist/vee-validate.esm";
import moment from "moment";
import laptopView from "@/views/profile/laptopView.vue";
import cInput from "@/components/FormElements/CustomInput";
import ColorPicker from "@/components/FormElements/ColorPicker.vue";
import ComponentHeader from "@/components/componentNewHeader";
import Vue from "vue";
import { EDITOR_URL } from "@/config";
Validator.extend("package-name", {
  validate: (value) => {
    if (!value) return true; // Optional field
    const packageNameRegex = /^([a-z][a-z0-9_]*\.)+[a-z][a-z0-9_]*$/;
    return packageNameRegex.test(value);
  },
  message:
    "Package name must follow reverse domain name notation (e.g. com.company.appname)",
});
export default {
  components: {
    AtomSpinner,
    profile,
    cInput,
    ColorPicker,
    VueUploadMultipleImage,
    SingleImage,
    mobileView,
    laptopView,
    ComponentHeader,
    ValidationProvider,
    ValidationObserver,
    ChooseAppPlatform,
    AppDetails,
    CustomizeBrandTheme,
    ConfigureSplashScreen,
    AppIconsAlerts,
    FinalizeBuild,
    DomainConfiguration,
  },
  mixins: [currentUserData],
  data() {
    return {
      addedProducts: false,
      isPaymentSetup: false,
      isDeliveryOption: false,
      isStoreAddressUpdated: false,
      isCreateStoreCredential: false,
      isSetupCurrency: false,
      user: {},
      selectedPlatform: "",
      tabIndex: 0,
      // googleClientId: "",
      appName: "",
      tagLine: "",
      appVersion: "",
      packageName: "",
      headerDefault: "#ff6e34",
      primary: "#2a8750",
      primaryLight: "#ff6e34",
      primaryDark: "#284397",
      primaryText: "#000000",
      footerBgColor: "#a1a1a1",
      footerTextColor: "#808080",
      // headerBgColor: "#fff",
      // headerTextColor: "#a1a1a1",
      // borderColor: "#ff8a00",
      buttonBgColor: "#ff8a00",
      buttonTextColor: "#fff",
      buttonHoverBgColor: "#f2f2f2",
      marketBgColor: "#f7f7f7",
      backgroundColor: "#E6F0FF",
      borderColor: "#0000001A",
      // white: "#ffffff",
      secondary: "#15E406",
      font: "#fff",
      headerTop: "#2a8750",
      headerBottom: "#284397",
      bgColor: "#ff6e34",
      headerFont: "#fff",
      footerNormal: "#2a8750",
      footerSelection: "#000000",
      status: "PENDING",
      headerPrimary: true,
      headerPrimaryDark: true,
      headerPrimaryLight: true,
      headerFontSelection: true,
      footerNormalSelection: true,
      footerSelectionActive: true,
      splashBGCol: "#ffffff",
      intervalId: "",
      images: {
        splashIcon: null,
        splashBGImage: null,
        notificationIcon: null,
        logo: null,
        loginBgImg: null,
      },
      filter: "",
      loading: false,
      hover: true,
      striped: false,
      bordered: true,
      small: false,
      fixed: false,
      dark: false,
      stepperIndex: 1,
      showGenerateBuildPopup: false,
      buildGenResponse: {},
      finalBuildStatus: "",
      headerCartIcon: true,
      headerWishlistIcon: true,
      headerNavs: true,
      businessKeyPoints: true,
      categorySection: true,
      webAdvcedCustomisation: "basic",
    };
  },
  computed: {
    ...mapState({
      extendedList: (state) => state.tenant.extendedList,
      userInfo: (state) => state.auth.userInfo,
      historyList: (state) => state.profile.history,
      buildIdData: (state) => state.profile.buildIdData,
      buildProgress: (state) => state.profile.buildProgress,
      systemConfig: (state) => state.profile.systemConfig,
    }),
    buildTimeRange() {
      switch (this.selectedPlatform) {
        case "web":
          return "3 to 6 Minutes";
        case "mobile":
        case "seller":
        case "agent":
          return "20 to 30 Minutes";
        default:
          return "a few minutes";
      }
    },
    ThemeNextButtonName() {
      return this.selectedPlatform === "web"
        ? this.$t("Generate Build")
        : this.$t("Next");
    },
    latestBuildArray() {
      const latest = this.historyList?.latest;
      if (!latest) return [];
      return Array.isArray(latest) ? latest : [latest];
    },
    columnsRecent() {
      return [
        {
          key: "appName",
          label: "App Name",
        },
        {
          key: "appType",
          label: "App Type",
        },
        {
          key: "version",
          label: "App Version",
        },
        {
          key: "status",
          label: "Status",
        },
        {
          key: "createdAt",
          label: "Generated On",
          formatter: (value) => moment(value).format("DD-MM-YYYY hh:mm A"),
        },
        {
          key: "buildFileUrl",
          label: "Download Link",
        },
        // {
        //   key: "action",
        //   label: "Action",
        // },
      ];
    },
    columnsPrevious() {
      return [
        {
          key: "appName",
          label: "App Name",
        },
        {
          key: "appType",
          label: "App Type",
        },
        {
          key: "version",
          label: "App Version",
        },
        {
          key: "status",
          label: "Status",
        },
        {
          key: "createdAt",
          label: "Generated On",
          formatter: (value) => moment(value).format("DD-MM-YYYY hh:mm A"),
        },
        {
          key: "buildFileUrl",
          label: "Download Link",
        },
        // {
        //   key: "action",
        //   label: "Action",
        // },
      ];
    },
    filteredData() {
      const rows = [];
      if (
        this.historyList &&
        Array.isArray(this.historyList.history) &&
        this.historyList.history.length > 0
      ) {
        this.historyList.history.forEach((entry) => {
          const formatDate = (date) => this.$formatWithMoment(date) || null;

          // Web Customer
          if (entry.web?.customer) {
            const { startedAt, buildFileUrl, status, buildVersion } = entry.web.customer;
            rows.push({
              requested_date: formatDate(startedAt),
              app_type: "Web Customer",
              url: buildFileUrl || null,
              status: status || null,
              build_version: buildVersion || "-",
            });
          }

          // Android Customer
          if (entry.android?.customer) {
            const {
              startedAt,
              buildFileUrl,
              status,
              buildVersion,
            } = entry.android.customer;
            rows.push({
              requested_date: formatDate(startedAt),
              app_type: "Android Customer",
              url: buildFileUrl || null,
              status: status || null,
              build_version: buildVersion || "-",
            });
          }

          // Android Seller
          if (entry.android?.seller) {
            const {
              startedAt,
              buildFileUrl,
              status,
              buildVersion,
            } = entry.android.seller;
            rows.push({
              requested_date: formatDate(startedAt),
              app_type: "Android Seller",
              url: buildFileUrl || null,
              status: status || null,
              build_version: buildVersion || "-",
            });
          }

          // Android Agent
          if (entry.android?.agent) {
            const { startedAt, buildFileUrl, status, buildVersion } = entry.android.agent;
            rows.push({
              requested_date: formatDate(startedAt),
              app_type: "Android Agent",
              url: buildFileUrl || null,
              status: status || null,
              build_version: buildVersion || "-",
            });
          }
        });
      }

      return rows;
    },
  },
  methods: {
    capitalizeFirstLetter(string) {
      if (!string) return "";
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    async navigateToAdvancedCustomisation() {
      const userLogin = sessionStorage.getItem("userLogin") || "";
      const sessionKey = this.randomKey(48); // Generate a high-entropy session key
      if (userLogin) {
        const { token, _id } = JSON.parse(userLogin);
        console.log(_id);
        await fetch(`${EDITOR_URL}/api/session/put`, {
          method: "POST",
          headers: {
            "content-type": "application/json",
            authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({
            sessionKey,
            tenant: _id,
          }), // sessionKey must be high-entropy URL-safe
        });
        location.href = `${EDITOR_URL}/deeplink?sessionKey=${sessionKey}`; // Redirect to editor with sessionKey
      }
    },
    // Generate on Vue side (Node util or small helper)
    randomKey(bytes = 24) {
      const arr = new Uint8Array(bytes);
      crypto.getRandomValues(arr);
      return btoa(String.fromCharCode(...arr))
        .replace(/\+/g, "-")
        .replace(/\//g, "_")
        .replace(/=+$/, "");
    },

    async getProgressSteps(BuildId) {
      if (this.buildProgressInterval) {
        clearInterval(this.buildProgressInterval);
      }

      const pollBuildProgress = async () => {
        await this.$store.dispatch("profile/getBuildProgressAction", BuildId);
        const phases = (this.buildProgress && this.buildProgress.phases) || [];
        const isDone = phases.some(
          (p) => p.phaseType === "COMPLETED" || p.phaseType === "FAILED"
        );
        if (isDone && this.buildProgressInterval) {
          clearInterval(this.buildProgressInterval);
          this.buildProgressInterval = null;
        }
      };
      // Initial call
      await pollBuildProgress();
      this.buildProgressInterval = setInterval(pollBuildProgress, 60000);
    },
    async getBuildIdMethod(id, name) {
      const pipelineName = name;
      const executionId = id;

      const payload2 = {
        id: executionId || "",
        type: pipelineName || "",
      };

      // Wait 15 seconds before the first API call
      await new Promise((resolve) => setTimeout(resolve, 15000));
      await this.$store.dispatch("profile/getExecutionIdAction", payload2);

      const getBuildId = () => {
        try {
          const buildStage = this.buildIdData?.stats?.find(
            (stage) => stage.stageName === "Build"
          );
          const buildAction = buildStage?.actions?.find((action) => action.buildId);
          return buildAction?.buildId || null;
        } catch (e) {
          return null;
        }
      };

      let BuildId = getBuildId();

      // ✅ If BuildId found after first call, skip polling
      if (BuildId) {
        await this.getProgressSteps(BuildId);
        return;
      }

      // Otherwise, poll until found
      await new Promise((resolve) => {
        const buildIdPollInterval = setInterval(async () => {
          await this.$store.dispatch(
            "profile/getExecutionIdAction",
            { id: executionId || "", type: pipelineName || "" } // fresh payload
          );
          BuildId = getBuildId();
          if (BuildId) {
            clearInterval(buildIdPollInterval);
            resolve();
          }
        }, 5000);
      });

      await this.getProgressSteps(BuildId);
    },

    async checkBuildProgress(data) {
      await this.$store.dispatch("profile/clearBuildProgress");
      this.tabIndex = 0;
      if (data.platform == "web") {
        this.selectedPlatform = "web";
        this.stepperIndex = 4;
      } else {
        this.selectedPlatform = "";
        this.stepperIndex = 6;
      }
      if (data.buildId) {
        await this.getProgressSteps(data.buildId);
      } else {
        await this.getBuildIdMethod(data.executionId, data.pipelineName);
      }
    },
    goToCreateNewBuild() {
      this.stepperIndex = 1;
      // Reset all build config related data
      this.selectedPlatform = "";
      this.appName = "";
      this.appVersion = "";
      this.packageName = "";
      // this.googleClientId = "";
      this.tagLine = "";
      this.primary = "#2a8750";
      this.primaryLight = "#ff6e34";
      this.primaryDark = "#284397";
      this.primaryText = "#000000";
      this.footerBgColor = "#a1a1a1";
      this.footerTextColor = "#808080";
      this.marketBgColor = "#f7f7f7";
      this.font = "#fff";
      this.headerTop = "#2a8750";
      this.headerBottom = "#284397";
      this.bgColor = "#ff6e34";
      this.headerFont = "#fff";
      this.footerNormal = "#2a8750";
      this.footerSelection = "#000000";
      this.splashBGCol = "#ffffff";
      this.images = {
        splashIcon: null,
        splashBGImage: null,
        notificationIcon: null,
        logo: null,
        loginBgImg: null,
      };
      // this.market = [];
      // this.status = "PENDING";
      this.buildGenResponse = {};
      this.finalBuildStatus = "";
      // this.$refs.observer?.reset?.();
      // Optionally reset any other UI or state as needed
    },
    handleChooseAppPlatformNext(data) {
      this.selectPlatform = data;
      this.stepperIndex = 2;
    },
    handleAppDetailsNext(data) {
      let errorMsg = "";
      // if (!data.appName || !data.googleClientId) {
      //   errorMsg = "Please fill all required fields";
      // }
      if (!data.appName) {
        errorMsg = "Please fill all required fields";
      }
      if (this.selectedPlatform === "web" && !data.tagLine) {
        errorMsg = "Please fill all required fields";
      }
      if (this.selectedPlatform !== "web" && !data.appVersion) {
        errorMsg = "Please fill all required fields";
      }
      if (this.images.loginBgImg === null) {
        errorMsg = "Please upload a login background image";
      }
      if (
        this.selectedPlatform !== "web" &&
        data.packageName &&
        !/^([a-z][a-z0-9_]*\.)+[a-z][a-z0-9_]*$/.test(data.packageName)
      ) {
        errorMsg =
          "Package name must follow reverse domain name notation (e.g. com.company.appname)";
      }
      if (errorMsg) {
        this.$toasted.info(errorMsg);
        return;
      }
      this.appName = data.appName;
      this.appVersion = data.appVersion;
      this.packageName = data.packageName;
      // this.googleClientId = data.googleClientId;
      this.tagLine = data.tagLine;
      this.stepperIndex = 3;
    },
    handleCustomizeBrandThemeNext(data) {
      let errorMsg = "";
      if (this.images.logo === null) {
        errorMsg = "Please upload a brand logo";
      }
      if (errorMsg) {
        this.$toasted.info(errorMsg);
        return;
      }
      this.primary = data.primary;
      this.primaryLight = data.primaryLight;
      this.primaryDark = data.primaryDark;
      this.primaryText = data.primaryText;
      this.headerFont = data.headerFont;
      this.footerSelection = data.footerSelection;
      this.footerNormal = data.footerNormal;
      this.footerBgColor = data.footerBgColor;
      this.footerTextColor = data.footerTextColor;
      this.marketBgColor = data.marketBgColor;
      this.secondary = data.secondary;
      this.borderColor = data.borderColor;
      this.backgroundColor = data.backgroundColor;
      // this.white = data.white;
      if (this.selectedPlatform === "web") {
        this.showGenerateBuildPopup = true;
        setTimeout(() => {
          this.stepperIndex = 4;
        }, 5000);
      } else {
        this.stepperIndex = 4;
      }
    },
    handleSplashScreenNext(data) {
      let errorMsg = "";
      if (this.images.splashIcon === null) {
        errorMsg = "Please upload a splash image";
      }
      if (errorMsg) {
        this.$toasted.info(errorMsg);
        return;
      }
      this.splashBGCol = data.splashBGCol;
      this.stepperIndex = 5;
    },
    shouBuildGenerationPopup() {
      let errorMsg = "";
      if (this.images.notificationIcon === null) {
        errorMsg = "Please upload a notification icon";
      }
      if (errorMsg) {
        this.$toasted.info(errorMsg);
        return;
      }
      this.showGenerateBuildPopup = true;
    },
    handleAppIconsAlertsNext(data) {
      if (this.selectedPlatform === "web") {
        this.stepperIndex = 4;
      } else {
        this.stepperIndex = 6;
      }
      // this.status = "PENDING";
    },
    goToBuildActivity() {
      this.fetchStatus(true);
      this.tabIndex = 1;
    },
    retryBuild() {
      // Re-trigger build process
      this.generateBuild();
    },
    editBuildSetting() {
      // Go back to build configuration steps
      this.stepperIndex = 1;
    },
    handleBuildStatus(status) {
      this.finalBuildStatus = status;
      // Use the build status here
    },
    async handleAddProduct() {
      const isFirstProduct = !this.extendedList?.taskCreated?.includes("productConfig");
      this.$router.push({
        path: "/item/createV2",
        query: { firstProduct: isFirstProduct },
      });
    },
    async handleUpdateStoreAddress() {
      const isStoreAddressUpdated = !this.extendedList?.taskCreated?.includes(
        "storeAddressConfig"
      );
      const response = await this.$store.dispatch("item/getProviderId");
      const data =
        (response &&
          response.data &&
          response.data.response &&
          response.data.response[0]) ||
        "";
      this.$store.dispatch("partner/editPartnerData", data);

      this.$router.push({
        name: "basic-info",
        params: { id: data._id },
        query: { storeAddress: isStoreAddressUpdated },
      });
    },
    async handleCreateStoreCredentials() {
      const isStoreCredentialCreate = !this.extendedList?.taskCreated?.includes(
        "storeCredentialsConfig"
      );
      const response = await this.$store.dispatch("item/getProviderId");
      const data =
        (response &&
          response.data &&
          response.data.response &&
          response.data.response[0]) ||
        "";
      await this.$store.dispatch("partner/editPartnerData", data);

      this.$router.push({
        name: "basic-info",
        params: { id: data._id },
        query: { isStoreCredentialCreate: isStoreCredentialCreate },
      });
    },
    async handleSetupCurrency() {
      const isCurrencySetup = !this.extendedList?.taskCreated?.includes(
        "setupCurrencyConfig"
      );

      this.$router.push({
        path: "/settingsConfigurations/currencySettings",
        query: { isCurrencySetup: isCurrencySetup },
      });
    },
    async handleDeliveryConfig() {
      const payload = {
        taskCompleted: ["delivaryConfig"],
      };
      try {
        await this.$store.dispatch("tenant/tenantConfig", payload);
        this.$router.push(
          `/settingsConfigurations/deliveryConfig?isDeliveryOption=${this.isDeliveryOption}`
        );
      } catch (error) {
        console.error("API Error:", error);
      }
    },
    async handlePaymentConfig() {
      const payload = {
        taskCompleted: ["paymentConfig"],
      };
      try {
        await this.$store.dispatch("tenant/tenantConfig", payload);
        this.$router.push(
          `/settingsConfigurations/paymentConfig?isPaymentSetup=${this.isPaymentSetup}`
        );
      } catch (error) {
        console.error("API Error:", error);
      }
    },

    containerHeight() {
      if (this.selectedPlatform === "web") return "height:56rem;";
      return "height:80rem;";
    },
    primaryColorChange(val) {
      this.primary = val;
      this.primaryUpdate();
    },
    changeSplashBGImage(val) {
      this.splashBGImage = val || null;
    },
    changeSplashIcon(val) {
      this.splashIcon = val || null;
    },
    resetSplashScreen() {
      this.images.splashBGImage = "";
      this.images.splashIcon = "";
      if (this.$refs.splashBGImage) {
        this.$refs.splashBGImage.reset();
      }
      if (this.$refs.splashIcon) {
        this.$refs.splashIcon.reset();
      }
      this.splashBGCol = "#ffffff";
      this.$refs["splash-bg-colour"]?.updateColor(this.splashBGCol);
    },
    primaryUpdate() {
      if (this.headerPrimary) {
        this.headerTop = this.primary;
        this.$refs["headerTop"]?.updateColor(this.primary);
      }
      if (this.headerPrimaryDark) {
        this.headerBottom = this.primaryDark;
        this.$refs["headerBottom"]?.updateColor(this.primaryDark);
      }
      if (this.headerPrimaryLight) {
        this.bgColor = this.primaryLight;
        this.$refs["bg-color"]?.updateColor(this.primaryLight);
      }
      if (this.headerFontSelection) {
        this.headerFont = this.font;
        this.$refs["headerFont"]?.updateColor(this.font);
      }
      if (this.footerNormalSelection) {
        this.footerNormal = this.primary;
        this.$refs["footer-normal-colour"]?.updateColor(this.primary);
      }
      if (this.footerSelectionActive) {
        this.footerSelection = this.primaryLight;
        this.$refs["footer-sel-colour"]?.updateColor(this.primaryLight);
      }
    },
    showCustomToast() {
      Vue.toasted.show("Uploading...", {
        type: "info",
        theme: "toasted-primary",
        singleton: true,
        duration: 1000000,
      });
    },
    clearCustomToast() {
      Vue.toasted.clear();
    },
    async uploadImage(path, image) {
      let dataobj = {
        image: image,
        key: (
          Date.now().toString(36) + Math.random().toString(36).substr(2, 5)
        ).toLowerCase(),
        isPublic: true,
        replaceExisting: true,
        basePath: "tenant",
      };
      this.showCustomToast();
      await this.$store
        .dispatch("inventory/uploadImageToStorage", dataobj)
        .then((res) => {
          this.clearCustomToast();
          this.images[path] = res.data.fileUrl;
        })
        .catch((error) => {
          this.clearCustomToast();
          this.$toasted.error("Image not uploaded. Please try again!");
        });
    },
    formatDateTime: function (value) {
      if (!value) {
        return "-";
      }
      return moment(value).format("DD/MM/YYYY  h:mm A");
    },
    buildPayload() {
      const payload = {
        tenant: this.$currentUserData._id,
        type: this.selectedPlatform === "web" ? "web" : "mobile",
        data: {
          type: this.selectedPlatform === "web" ? "web" : "mobile",
          appName: this.appName,
        },
        ...(this.selectedPlatform !== "web" && {
          appType:
            this.selectedPlatform === "seller"
              ? "sellerApp"
              : this.selectedPlatform === "agent"
              ? "agentApp"
              : "customerApp",
        }),
      };

      if (this.selectedPlatform === "web") {
        payload.data = {
          ...payload.data,
          tagline: this.tagLine,
          dynamicFields: {
            headerCartIcon: this.headerCartIcon,
            headerWishlistIcon: this.headerWishlistIcon,
            headerNavs: this.headerNavs,
            businessKeyPoints: this.businessKeyPoints,
            categorySection: this.categorySection,
          },
          theme: {
            icon: this.images.logo,
            loginBackground: this.images.loginBgImg,
            logo: this.images.logo,
            primary: this.primary,
            primaryGradient: this.primaryDark,
            primaryLight: this.primaryLight,
            primaryText: this.primaryText,
            secondary: this.footerBgColor,
            secondaryText: this.footerTextColor,
          },
          service: {
            url: "",
            tenant: this.$currentUserData._id,
            googleClientId:
              this.systemConfig.googleMapKey ||
              "AIzaSyAouz8rFGlw0mzOwrryd4_ZY0ZYSPq-m-o",
            cashFreeMode: "production",
          },
        };
      } else {
        payload.data = {
          ...payload.data,
          platform:
            this.selectedPlatform === "mobile"
              ? "mobile"
              : this.selectedPlatform === "seller"
              ? "seller"
              : "agent",
          version: this.appVersion,
          packageName: this.packageName,
          baseUrl: "",
          bucketBaseurl: "https://nipigedev-storage.s3.amazonaws.com",
          gApiKey:
            this.systemConfig.googleMapKey ||
            "AIzaSyAouz8rFGlw0mzOwrryd4_ZY0ZYSPq-m-o",
          currency: this.userInfo?.preferences?.currency?.symbol || "$",
          cashFreeEnv: "production",
          tenant: this.$currentUserData._id,
          legal: "https://eparisheva.com/#/privacy-policy",
          travelMarketId: "travel",
          rechargeMarketId: "recharge",
          theme: {
            splashScreen: {
              bgColor: this.splashBGCol,
              // bgImage: this.images.splashBGImage,
              bgIcon: this.images.splashIcon,
            },
            logo: {
              app: this.images.logo,
              notification: this.images.notificationIcon,
            },
            colorSchema: {
              primaryLight: this.primaryLight,
              basicColor: this.primaryLight,
              statusBarBgColor: this.primary,
              defaultAppIconColor: this.footerNormal,
              selectedAppIconColor: this.footerSelection,
              defaultAppIconTextColor: this.footerNormal,
              selectedAppIconTextColor: this.footerSelection,
              primary: this.primary,
              secondary: this.secondary,
              borderColor: this.borderColor,
              backgroundColor: this.backgroundColor,
              // white: this.white,
              headerFontColor: this.headerFont,
              headerGradient: [this.primary, this.primaryDark],
            },
          },
          font: {
            fontSize: 12,
            fontColor: "Black",
            fontWeight: 400,
            fontFamily: "Montserrat-Regular",
          },
        };
      }

      return payload;
    },
    async generateBuild() {
      const isValid = await this.$refs.observer.validate();
      if (!isValid) {
        this.$swal({
          title: "Please fill all the fields",
          type: "warning",
        });
        return;
      }
      if (!this.selectedPlatform) {
        this.$toasted.info("Please select a platform!");
        return;
      }
      if (!this.primary.length || !this.primaryLight.length || !this.primaryDark.length) {
        this.$toasted.info("Please select all colors!");
        return;
      }
      if (!this.images.logo) {
        this.$toasted.info("Please upload logo!");
        return;
      }
      if (this.selectedPlatform === "web" && !this.images.loginBgImg) {
        this.$toasted.info("Please upload Login screen image!");
        return;
      }
      // if (!this.googleClientId.length) {
      //   this.$toasted.info("Please enter google client id");
      //   return;
      // }

      const payload = this.buildPayload();

      try {
        await this.$store.dispatch("profile/buildConfig", payload);
        await this.buildConfig();
        if (this.buildGenResponse && !this.buildGenResponse.executionId) return;
        if (this.selectedPlatform === "web") {
          const updatePayload = {
            id: this.$currentUserData._id,
            data: {
              web: {
                customer: {
                  appName: this.appName,
                },
              },
            },
          };
          await this.$store.dispatch(
            "profile/updateBuildApplicationAction",
            updatePayload
          );
        }
        this.fetchStatus(true);
        this.handleAppIconsAlertsNext();
        const payload2 = {
          id: this.buildGenResponse.executionId || "",
          type: this.buildGenResponse.pipelineName || "",
        };
        // Call getExecutionIdAction after 15 seconds
        await new Promise((resolve) => setTimeout(resolve, 15000));
        await this.$store.dispatch("profile/getExecutionIdAction", payload2);

        // Try to get BuildId, if not found, poll getExecutionIdAction every 5 seconds until found
        let BuildId = null;
        let buildIdPollInterval = null;
        const getBuildId = () => {
          try {
            const buildStage = this.buildIdData.stats.find(
              (stage) => stage.stageName === "Build"
            );
            if (buildStage) {
              const buildAction = buildStage.actions.find((action) => action.buildId);
              if (buildAction) {
                return buildAction.buildId;
              }
            }
          } catch (e) {}
          return null;
        };

        BuildId = getBuildId();
        if (!BuildId) {
          await new Promise((resolve) => {
            buildIdPollInterval = setInterval(async () => {
              await this.$store.dispatch("profile/getExecutionIdAction", payload2);
              BuildId = getBuildId();
              if (BuildId) {
                clearInterval(buildIdPollInterval);
                resolve();
              }
            }, 5000);
          });
        }

        // Poll build progress every 1 minute until COMPLETED or FAILED
        if (this.buildProgressInterval) {
          clearInterval(this.buildProgressInterval);
        }

        const pollBuildProgress = async () => {
          await this.$store.dispatch("profile/getBuildProgressAction", BuildId);
          const phases = (this.buildProgress && this.buildProgress.phases) || [];
          const isDone = phases.some(
            (p) => p.phaseType === "COMPLETED" || p.phaseType === "FAILED"
          );
          if (isDone && this.buildProgressInterval) {
            clearInterval(this.buildProgressInterval);
            this.buildProgressInterval = null;
          }
        };
        // Initial call
        await pollBuildProgress();
        this.buildProgressInterval = setInterval(pollBuildProgress, 60000);
      } catch (error) {
        this.$toasted.error(error.message || "Failed to generate build");
        console.error(error);
      }
    },
    async buildConfig() {
      if (!this.selectedPlatform) {
        this.$toasted.info("Please select a platform");
        return;
      }

      const buildTypeMap = {
        mobile: 0,
        seller: 1,
        agent: 2,
        web: 3,
      };

      const data = {
        buildTypes: [buildTypeMap[this.selectedPlatform]],
        tenant: this.$currentUserData._id,
      };

      const featureMap = {
        web: "Generate Customer Website",
        mobile: "Generate Customer App",
        seller: "Generate Seller App",
        agent: "Generate Agent App",
      };
      try {
        await this.$store.dispatch("profile/buildGenerate", data).then((respData) => {
          // If status == 0, show message and stop
          if (respData && respData.data && respData.data.status === 0) {
            this.$swal({
              text: respData.data.message || "Build initiation failed.",
              type: "error",
            });
            return;
          } else {
            this.buildGenResponse =
              (respData && respData.data && respData.data.response) || {};
            this.$store.commit("auth/updatePlanLimitation", {
              key: "GENERATE_APPLICATION_BUILD",
              feature: featureMap[this.selectedPlatform],
              count: 1,
            });
            this.$swal({
              text: "Build Execution in process...",
              type: "success",
            });
          }

          // If only web is selected (no phn and no seller), start an interval to periodically fetch the status.
          // if (this.web && !this.phn && !this.seller && !this.agent) {
          //   this.intervalId = setInterval(() => {
          //     this.fetchStatus();
          //   }, 20000);
          // }
        });
      } catch (error) {
        // Only show toast if not already handled by swal above
        if (!error.message || error.message === "Failed to initiate build") {
          this.$toasted.error(error.message || "Failed to initiate build");
        }
      }
    },
    clearPage() {
      this.selectedPlatform = null;
      this.appName = "";
      this.appVersion = "";
      this.packageName = "";
      // this.googleClientId = "";
      this.tagLine = "";
      this.primary = "#2a8750";
      this.primaryLight = "#ff6e34";
      this.primaryDark = "#284397";
      this.footerBgColor = "#a1a1a1";
      this.footerTextColor = "#808080";
      this.marketBgColor = "#f7f7f7";
      this.font = "#fff";
      this.headerTop = "#2a8750";
      this.headerBottom = "#284397";
      this.bgColor = "#ff6e34";
      this.headerFont = "#fff";
      this.footerNormal = "#2a8750";
      this.footerSelection = "#000000";
      this.splashBGCol = "#ffffff";
      this.images = {
        splashIcon: null,
        splashBGImage: null,
        notificationIcon: null,
        logo: null,
        loginBgImg: null,
      };
      this.headerCartIcon = true;
      this.headerWishlistIcon = true;
      this.headerNavs = true;
      this.businessKeyPoints = true;
      this.categorySection = true;
      this.status = "PENDING";
      this.$refs.observer?.reset();
      if (this.$refs["splash-bg-colour"]) {
        this.$refs["splash-bg-colour"].updateColor(this.splashBGCol);
      }
      if (this.$refs["primary-colour"]) {
        this.$refs["primary-colour"].updateColor(this.primary);
      }
      if (this.$refs["header-primary"]) {
        this.$refs["header-primary"].updateColor(this.primaryLight);
      }
      if (this.$refs["primary-dark-colour"]) {
        this.$refs["primary-dark-colour"].updateColor(this.primaryDark);
      }
    },
    async fetchStatus(showPopup = false) {
      this.loading = true;
      try {
        const payload = {
          id: this.$currentUserData._id,
        };
        const resp = await this.$store.dispatch("profile/buildStatusAction", payload);
        if (resp && Array.isArray(resp.history) && resp.history.length > 0) {
          resp.history.forEach((entry) => {
            const platformStatusMap = {
              web: entry.web?.customer,
              mobile: entry.android?.customer,
              seller: entry.android?.seller,
              agent: entry.android?.agent,
            };

            const currentPlatform = platformStatusMap[this.selectedPlatform];
            if (currentPlatform?.status === "Completed") {
              const url = currentPlatform.buildFileUrl;
              this.status = "Completed";
              this.$swal({
                type: "success",
                title:
                  this.selectedPlatform === "web"
                    ? "Visit your website"
                    : "Download your app",
                showCloseButton: true,
                showCancelButton: true,
                focusConfirm: false,
                confirmButtonText: `Open`,
                cancelButtonText: `Later`,
              }).then((result) => {
                if (result.value) {
                  window.open(url, "_blank");
                } else if (result.isDenied) {
                  swal.close();
                }
              });
              clearInterval(this.intervalId);
            } else if (currentPlatform?.status && showPopup) {
              this.status = currentPlatform.status;
              this.$swal({
                title: "",
                text: `${
                  this.selectedPlatform === "web"
                    ? "Web Customer"
                    : this.selectedPlatform === "mobile"
                    ? "Mobile Customer"
                    : this.selectedPlatform === "seller"
                    ? "Mobile Seller"
                    : "Mobile Agent"
                } - ${currentPlatform.status}`,
                type: "success",
                timer: 5000,
                showCancelButton: false,
                showConfirmButton: false,
              });
            } else if (currentPlatform?.status) {
              this.status = currentPlatform.status;
            }
          });
        }
      } catch (err) {
        console.error("Error fetching status:", err);
      }
      this.loading = false;
    },
    async fetchTenantConfig() {
      let payload = {};
      try {
        const response = await this.$store.dispatch(
          "tenant/actionTenantConfigList",
          payload
        );

        const taskCreated = response?.data?.response?.taskCreated || [];
        this.addedProducts = taskCreated.includes("productConfig");
        this.isPaymentSetup = taskCreated.includes("paymentSetup");
        this.isDeliveryOption = taskCreated.includes("delivaryConfig");
        this.isStoreAddressUpdated = taskCreated.includes("storeAddressConfig");
        this.isCreateStoreCredential = taskCreated.includes("storeCredentialsConfig");
        this.isSetupCurrency = taskCreated.includes("setupCurrencyConfig");
        if (response?.data?.response?.preferences?.advancedBuild == "advanced")
          this.webAdvcedCustomisation = "advanced";
      } catch (error) {
        console.error("Error fetching taskCreated config:", error);
      }
    },
    async confirmGenerateBuild() {
      this.showGenerateBuildPopup = false;
      await this.$store.dispatch("profile/clearBuildProgress");
      this.generateBuild();
    },
    cancelGenerateBuild() {
      this.showGenerateBuildPopup = false;
    },
  },
  async mounted() {
    this.loading = true;
    await this.$store.dispatch("tenant/setExtendedAttributeList", {});
    this.user = this.$store.getters["auth/getloginUser"];
    await this.$store.dispatch("profile/getSystemConfig");
    await this.$store.dispatch("profile/buildStatusAction", {
      id: this.$currentUserData._id,
    });
    await this.fetchTenantConfig();
    this.loading = false;
  },
  watch: {
    selectedPlatform: {
      immediate: true,
      handler(newVal) {
        const platformConfig = this.extendedList.buildConfig[newVal];
        this.images.loginBgImg = platformConfig?.theme?.loginBackground || "";
        this.images.logo = platformConfig?.theme?.logo || "";
      },
    },
    tabIndex(newVal) {
      if (newVal === 3) {
        this.$store.dispatch("tenant/setExtendedAttributeList", {});
      }
    },
  },
  created() {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  },
};
</script>
<style>
.input-group {
  position: relative;
}

.input-group .b-form-input {
  padding-right: 30px;
}
.package-info {
  border-radius: 0.25rem !important;
}
.info-tooltip {
  right: 0;
  z-index: 10;
  height: 100%;
  display: flex;
  align-items: center;
  padding-right: 10px;
}
.language-button button {
  width: 160px;
  margin-bottom: 15px;
  margin-left: 15px;
  margin-right: 15px;
  font-size: 14px;
}

.card-img-top {
  height: 70px;
  width: auto;
  max-width: 100%;
}

.card-body {
  padding: 15px;
}

.card-footer {
  border-top: 2px dashed #c8d1d7;
}

@media (max-width: 768px) {
  .language-button button {
    width: 100%;
    margin-left: 0;
    margin-right: 0;
  }
}

.center {
  text-align: center;
}

.headclass .thead-light th {
  color: var(--secondary);
  background-color: #f1f3fa;
  border-color: #e3eaef;
  padding: 1rem;
}

.headclass .thead-light {
  border-radius: 10px;
}

.headclass td {
  border-top: 1px solid #f1f5f8;
}

.description {
  color: black;
}

.round {
  border-radius: 50%;
  height: 30px;
  width: 30px;
  padding: 0;
}

.header-text .modal-title {
  font-size: 1.2rem;
  color: #4140e2;
  text-align: left;
}

.modal-content {
  padding: 1rem;
}

select.form-control:not([size]):not([multiple]) {
  height: calc(3.2125rem - 6px);
}

.custom-file-label::after {
  background-color: #727cf5 !important;
  color: #fff !important;
  line-height: 1.2 !important;
}

.theme {
  height: 47px;
  margin-top: -3px;
  width: 53px;
}

.color-input {
  width: 350px !important;
  margin-left: 7px !important;
  height: 40px !important;
  margin-top: 1px !important;
}

.icon {
  height: 38px !important;
  margin-left: 5rem !important;
  margin-top: 1px;
}

.slug-name {
  width: 380px !important;
}

.slug {
  margin-left: 52px !important;
}

.purple-bg {
  background: #e9e7ff3b;
  border: 1px solid #dee3ea;
  min-height: 1rem !important;
}

.heading-purple {
  color: #3b3ad9;
  font-size: 15px;
  text-transform: uppercase;
}

h4 {
  margin-bottom: 1rem;
}

.preview-area {
  position: relative;
  margin: 3rem 0 4rem; /* Increased vertical margins */
  margin-bottom: 60px;
}

.mobile {
  position: relative;
  z-index: 2;
  top: 50px;
}

.platform-group div {
  display: flex;
  gap: 30px;
  align-items: center;
}
.display-group div {
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 10px;
}

.platform-group div label h4 {
  margin-top: 4px !important;
}
.preview-container {
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  gap: 4rem; /* Increased gap between items */
  width: 100%;
  flex-wrap: wrap;
}

.preview-item {
  flex: 0 1 auto;
  display: flex;
  justify-content: center;
}
::v-deep .absolute[data-v-a1540672] {
  position: relative !important;
}
.url-link {
  color: #007bff;
  text-decoration: none;
  cursor: pointer;
  word-break: break-all;
}

.url-link:hover {
  color: #0056b3;
  text-decoration: underline;
}

.url-link:visited {
  color: #6610f2;
}
</style>
<style scoped>
.stepper-btn-row {
  display: flex;
  justify-content: center;
  gap: 16px;
  margin-top: 32px;
}
.stepper-btn {
  min-width: 140px;
  font-size: 14px;
  padding: 6px 18px;
  box-shadow: none;
}
.step-title {
  text-align: center;
  line-height: 1.2;
  margin-top: 8px;
  font-size: 14px;
}

.v-stepper__step {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.icon {
  font-size: 16px;
  color: white;
}

.v-stepper--alt-labels .v-stepper__step {
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
}

.v-stepper--alt-labels .v-stepper__step .v-stepper__label {
  margin-top: 8px;
  text-align: center;
}
.v-stepper {
  box-shadow: none;
  margin-top: 0;
}
.tab-pane {
  padding: 0;
}

.v-stepper__header {
  box-shadow: none;
}
.user_bg_color {
  background: #f2f5f9 !important;
}
.v-stepper__content {
  padding: 0 20px 10px 20px !important;
}
.v-stepper__step__step {
  height: 35px !important;
  min-width: 35px !important;
}
::v-deep .modal-content {
  padding: 0 !important;
}
::v-deep .modal-header {
  margin: 0 !important;
}
.popup-btn-row {
  display: flex;
  justify-content: center;
  gap: 18px;
  margin: 10px 0 20px 0;
}
.popup-btn {
  min-width: 90px;
  max-width: 120px;
  font-size: 13px;
  padding: 5px 16px;
  box-shadow: none;
}
.hight {
  height: 165px;
}
@media (max-width: 580px) {
  .v-stepper__header {
    display: none;
  }
  .choose-platform-container {
    margin-top: 20px;
    margin-bottom: 20px;
  }
}
/* Table responsive - medium screens (≤991px) */
@media (max-width: 991px) {
  .tableRadius.table-bordered {
    min-width: 700px;
  }
  .tableRadius + .table-responsive,
  .table-responsive .tableRadius {
    -webkit-overflow-scrolling: touch;
  }
}
/* Table responsive - small & mobile (≤768px) */
@media (max-width: 768px) {
  .tableRadius.table-bordered {
    min-width: 650px;
  }
  .table-bordered td {
    height: auto;
    min-height: 40px;
    padding: 0.5rem 0.75rem;
    -webkit-padding-start: 0.75rem;
    padding-inline-start: 0.75rem;
    font-size: 0.875rem;
    color: #262626;
    word-break: break-word;
  }
  .table-bordered th {
    padding: 0.5rem 0.75rem;
    font-size: 0.875rem;
  }
  .atom-spinner {
    display: block !important;
    margin: 40px auto !important;
    float: none !important;
  }
}
/* Table responsive - mobile (≤576px) */
@media (max-width: 576px) {
  .tableRadius.table-bordered {
    min-width: 580px;
  }
  .table-bordered td,
  .table-bordered th {
    padding: 0.4rem 0.5rem;
    font-size: 0.8125rem;
  }
}
</style>
